/**
 * Input Component
 * Reusable form input with label and error handling
 */

import React from 'react';

const Input = ({
  label,
  type = 'text',
  name,
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  error,
  className = '',
  autoComplete,
  ...props
}) => {
  const inputId = name || `input-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`rf-form-group ${className}`}>
      {label && (
        <label htmlFor={inputId} className="rf-label">
          {label}
          {required && <span style={{ color: 'var(--rf-danger)' }}> *</span>}
        </label>
      )}
      <input
        id={inputId}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        autoComplete={autoComplete}
        className={`rf-input ${error ? 'rf-input-error' : ''}`}
        {...props}
      />
      {error && <span className="rf-input-error-text">{error}</span>}
    </div>
  );
};

export default Input;
